import { Component, OnInit, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'cc-webhook-types-dropdown',
  templateUrl: './webhook-types-dropdown.component.html',
  styleUrls: ['./webhook-types-dropdown.component.scss']
})
export class WebhookTypesDropdownComponent implements OnInit {
  showType = 'ALL';
  @Output() public selectionChanged = new EventEmitter<string>();

  constructor() {}

  ngOnInit() {}

  changeSelect() {
    this.selectionChanged.emit(this.showType);
  }
}
